import React                   from 'react';
import {quantities as tooltip} from 'pu-data/Tooltips';
import PropTypes               from 'prop-types';

import Tooltip    from './base/Tooltip';
import Label      from './base/Label';
import TextInput  from './base/TextInput';
import ErrorLabel from './base/ErrorLabel';

const Qty = props => (
  <TextInput inputClassName={"pcb-qty"} {...props} />
);

const Quantities = (props) => {
  const onChange = props.onChangeParameter;
  const {quantities} = props.parameters

  return (
    <div className="form-group">
      <Label label={props.label} required={props.required}/>
      &nbsp;
      <Tooltip id="qty-tooltip" title={props.tooltip}/>
      <div className="row">
        <div className="col-3">
          <Qty
            groupName={props.groupName}
            name={props.name}
            onChange={e => onChange('qty1', e.target.value, props.itemId)}
            value={quantities[0]}
            className={props.className}/>
        </div>
        <div className="col-3">
          <Qty
            groupName={props.groupName}
            name={props.name}
            onChange={e => onChange('qty2', e.target.value, props.itemId)}
            value={quantities[1]}
            className={props.className}/>
        </div>
        <div className="col-3">
          <Qty
            groupName={props.groupName}
            name={props.name}
            onChange={e => onChange('qty3', e.target.value, props.itemId)}
            value={quantities[2]}
            className={props.className}/>
        </div>
        <div className="col-3">
          <Qty
            groupName={props.groupName}
            name={props.name}
            onChange={e => onChange('qty4', e.target.value)}
            value={quantities[3]}
            className={props.className}/>
        </div>
      </div>
      <ErrorLabel error={props.error}/>
    </div>
  );
};

Quantities.defaultProps = {
  tooltip,
  required: true,
  label: 'Quantities',
  nameQty1: '',
  nameQty2: '',
  nameQty3: '',
  nameQty4: '',
  groupName: 'parameters',
  name: 'quantities',
  layout: 'inline',
};

Quantities.propTypes = {
  parameters: PropTypes.object.isRequired,
  onChangeParameter: PropTypes.func.isRequired,
}

export default Quantities;
